import React, { useState, useEffect } from 'react';
import { LoadingGrid, SimpleAlert, TableList } from '../../../../rbts/helpers';
import { MenuComponent } from '../../../../rbts/assets/ts/components';
import { useObtenerCodigosPromocionales } from '../hooks/CodigosPromocionalesHook';
import { ModalCRU } from '../_modals/ModalCRU';
import { actualizarCodigoPromocionalService } from '../../../service/promocionales/CodigosPromocionales';

type Props = {};

const View: React.FC<Props> = ({}) => {
  const [reload, setReload] = useState<number>(Math.random() * 40);
  const { list, loading } = useObtenerCodigosPromocionales(reload);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [registro, setRegistro] = useState<any | null>(null);

  const toggleActivo = async (row: any) => {
    try {
      await actualizarCodigoPromocionalService(row.id, { activo: !row.activo });
      SimpleAlert(
        row.activo ? 'Código desactivado' : 'Código activado',
        3000,
        'success'
      );
      setReload(Math.random() * 40);
    } catch (error: any) {
      if (error && error.response) {
        const { message } = error.response.data;
        SimpleAlert(message, 3000, 'error');
      }
    }
  };

  const columns: any = [
    {
      id: 'codigo',
      name: <div className="fw-bolder text-muted me-5">Código</div>,
      selector: (row: any) => row.codigo,
      cell: (row: any) => <span className="fw-bolder">{row.codigo}</span>,
      sortable: true,
      width: '15%',
    },
    {
      id: 'descuento',
      name: <div className="fw-bolder text-muted me-5">Descuento</div>,
      selector: (row: any) => Number(row.valor),
      cell: (row: any) => (
        <span>
          {row.tipo_descuento === 'PORCENTAJE'
            ? `${Number(row.valor)}%`
            : `$${Number(row.valor).toFixed(2)}`}
        </span>
      ),
      sortable: true,
      width: '12%',
    },
    {
      id: 'vigencia',
      name: <div className="fw-bolder text-muted me-5">Vigencia</div>,
      selector: (row: any) => row.vigencia_fin ?? '',
      cell: (row: any) => (
        <span>
          {row.vigencia_inicio
            ? new Date(row.vigencia_inicio).toISOString().split('T')[0]
            : 'Sin inicio'}
          {' — '}
          {row.vigencia_fin
            ? new Date(row.vigencia_fin).toISOString().split('T')[0]
            : 'Sin fin'}
        </span>
      ),
      sortable: true,
      width: '23%',
    },
    {
      id: 'usos',
      name: <div className="fw-bolder text-muted me-5">Usos</div>,
      selector: (row: any) => row.usos,
      cell: (row: any) => (
        <span>
          {row.usos} / {row.limite_usos > 0 ? row.limite_usos : '∞'}
        </span>
      ),
      sortable: true,
      width: '10%',
    },
    {
      id: 'estatus',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => (row.activo ? 'Activo' : 'Inactivo'),
      cell: (row: any) =>
        row.activo ? (
          <span className="badge badge-light-success fw-bold px-4 py-3">Activo</span>
        ) : (
          <span className="badge badge-light-danger fw-bold px-4 py-3">Inactivo</span>
        ),
      sortable: true,
      width: '12%',
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5"></div>,
      cell: (row: any) => (
        <div className="d-flex justify-content-end flex-shrink-0">
          <button
            type="button"
            className="btn btn-light btn-active-light-primary btn-sm me-2"
            onClick={() => {
              setRegistro(row);
              setShowModal(true);
            }}
          >
            Editar
          </button>
          <button
            type="button"
            className={`btn btn-sm ${
              row.activo
                ? 'btn-light-danger btn-active-danger'
                : 'btn-light-success btn-active-success'
            }`}
            onClick={() => toggleActivo(row)}
          >
            {row.activo ? 'Desactivar' : 'Activar'}
          </button>
        </div>
      ),
      sortable: false,
      width: '28%',
    },
  ];

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [loading]);

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className="flex-lg-row-fluid">
            <div className={`card card-xxl-stretch mb-xl-12`}>
              <div className="card-header border-0 pt-5 mt-4 d-flex">
                <div className="card-title align-items-start flex-column flex-grow-1"></div>
                <div className="text-end">
                  <button
                    type="button"
                    title="Nuevo código promocional"
                    onClick={() => {
                      setRegistro(null);
                      setShowModal(true);
                    }}
                    className={`btn btn-primary`}
                  >
                    <span className="indicator-label">Nuevo código</span>
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row gy-5 g-xl-8">
                  <div className="col-xl-12">
                    {loading ? (
                      <LoadingGrid text="Cargando..."></LoadingGrid>
                    ) : (
                      <TableList data={list} columns={columns}></TableList>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalCRU
        show={showModal}
        handleClose={(refresh) => {
          setShowModal(false);
          setRegistro(null);
          if (refresh) {
            setReload(Math.random() * 40);
          }
        }}
        registro={registro}
      ></ModalCRU>
    </>
  );
};

export { View };
